import React from 'react';
import { Link } from 'react-router';
import { prefixLink } from 'gatsby-helpers';
import Helmet from 'react-helmet';
import { config } from 'config';

import Shots from 'pages/components/shots';


if (typeof window !== 'undefined') {
  window.jQuery = require('jquery');
  var jribbble = require('jribbble');
}

const Design = React.createClass({
  getInitialState () {
   return {
     shots: false,
   }
  },
  componentDidMount () {
    if (typeof window !== 'undefined') {
   jQuery.jribbble.setToken('268c08e91cfc1cfd03e5debda0e39eeab84b68c851f27a600b95d255da524d8a');
   jQuery.jribbble.users('ckj').shots().then(function(res) {
     this.setState({
       shots: res
     });
   }.bind(this));
 }
  },
  render () {
    return (
      <div className="page">
        <Helmet
          title={'Design • ' + config.siteTitle}
          meta={[
            {"name": "description", "content": "Recent work from Chris Jennings"},
            {"name": "keywords", "content": "about, ckj, sentry, github, disqus, dribbble"},
          ]}
        />
        <h1>
          recent work on dribbble
        </h1>
        <hr/>
        <Shots shots={ this.state.shots }/>
      </div>
    )
  }
});

module.exports = Design;



// WEBPACK FOOTER //
// ./design.js